import styled from '@emotion/styled';
import {
  Row,
  Column,
  Divider,
  device,
  typography,
  Reveal,
} from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  hasSplitter?: boolean;
  id?: string;
}

const Host = styled(Reveal)`
  p {
    ${typography.p2}
  }
`;

const Header = styled.div`
  margin-bottom: 30px;

  @media ${device.tablet} {
    margin-bottom: 48px;
  }
`;

const Title = styled.h1`
  ${typography.h1}

  margin-bottom: 30px;

  @media ${device.tablet} {
    margin-bottom: 48px;
  }
`;

export const Intro = ({ children, title, hasSplitter, id }: IProps) => {
  return (
    <Host>
      <Row id={id}>
        <Column
          md={{
            width: hasSplitter ? 1 : 10 / 12,
            offset: { left: hasSplitter ? 0 : 1 / 12 },
          }}
        >
          {title && (
            <Header>
              <Title>{title}</Title>
              <Divider width="47px" />
            </Header>
          )}
          {children}
        </Column>
      </Row>
    </Host>
  );
};
